import { Attribute, Relationship, Resource } from 'json-api';
import { Translatable } from 'src/app/translation/translatable';
import { AtomResource } from '../classes/atom-resource';
import { Contract } from './contract.resource';

@Resource({
  type: 'contracttypes',
})
export class ContractType extends AtomResource {
  @Attribute() name?: Translatable;
  @Attribute() desc?: Translatable;

  @Relationship() contracts?: Contract[];

  get hasPaymentDimensions(): boolean {
    return this.id === '1';
  }
}
